import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../component/css/ServiceRequestItem.css";

const ServiceRequestItem = ({ srNo, description, type, status, recordid }) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`/ServiceNotesStatus/${recordid}`);
  };

  return (
    <table className="T-thiss">
      <tbody className="table-body">
        <tr onClick={handleRowClick} style={{ cursor: "pointer" }}>
          <td className="Dark">
            <Link
              to={`/ServiceNotesStatus/${recordid}`}
              onClick={(e) => e.stopPropagation()}
            >
              {srNo}
            </Link>
          </td>
          <td className="requestDescription">{description}</td>

          <td className="Part_exchange">
            <p className="sts-sts">{status}</p>
          </td>
          <td className="requestType">{type}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default ServiceRequestItem;
